import React, { useState, useEffect } from 'react';
import { FaBars } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';
import { auth, provider } from '../../firebase/Firebase'; // Adjusted import path
import { signInWithPopup, signOut } from 'firebase/auth';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [user, setUser] = useState(null); // Store logged-in user
  const location = useLocation();

  // Handle scroll event to change navbar style
  const handleScroll = () => {
    setIsScrolled(window.scrollY > 50);
  };

  // Handle window resize to toggle mobile menu
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
    if (window.innerWidth > 768) {
      setIsMobileMenuOpen(false); // Close mobile menu on resize
    }
  };

  // Handle Google login
  const handleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      setUser(result.user); // Store user data on successful login
    } catch (error) {
      console.error("Error during login:", error);
    }
  };

  // Handle logout
  const handleLogout = async () => {
    try {
      await signOut(auth);
      setUser(null); // Clear user data on logout
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setUser(user);
    });

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      unsubscribe();
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const navbarStyle = {
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: 1000,
    padding: '10px 20px',
    backgroundColor: isScrolled ? 'rgba(34, 34, 34, 0.8)' : 'transparent',
    backdropFilter: isScrolled ? 'blur(10px)' : 'none',
    transition: 'background-color 0.3s ease, backdrop-filter 0.3s ease',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: 'white',
    fontWeight: 'bold',
    fontFamily: "'Roboto', sans-serif",
  };

  const isLinkActive = (path) => location.pathname === path;

  const linkStyle = (isActive) => ({
    color: isActive ? 'orange' : 'white',
    marginRight: '20px',
    cursor: 'pointer',
    textDecoration: 'none',
    display: isMobile ? 'none' : 'inline-block', // Hide links when in mobile view
  });

  const mobileMenuStyle = {
    display: isMobileMenuOpen ? 'block' : 'none',
    position: 'absolute',
    top: '60px',
    left: 0,
    width: '100%',
    backgroundColor: 'rgba(34, 34, 34, 0.95)',
    padding: '20px',
    textAlign: 'left',
    zIndex: 999,
  };

  const mobileLinkStyle = {
    display: 'block', // Each link on a new line
    padding: '10px 0',
    color: 'white',
    textDecoration: 'none',
    cursor: 'pointer',
  };

  return (
    <nav style={navbarStyle}>
      {/* Hamburger Icon for Mobile */}
      {isMobile && (
        <FaBars
          size={30}
          style={{ cursor: 'pointer', marginRight: '20px' }}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        />
      )}

      {/* Links for Desktop View */}
      {!isMobile && (
        <div style={{ display: 'flex', flexGrow: 1 }}>
          <Link to="/" style={linkStyle(isLinkActive('/'))}>Home</Link>
          <Link to="/faq" style={linkStyle(isLinkActive('/faq'))}>Faq</Link>
          <Link to="/join" style={linkStyle(isLinkActive('/join'))}>Join</Link>
          <Link to="/discord" style={linkStyle(isLinkActive('/discord'))}>Discord</Link>
          <Link to="/support" style={linkStyle(isLinkActive('/support'))}>Help & Support</Link>
        </div>
      )}

      {/* Profile Section */}
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {user ? (
          <>
            <img src={user.photoURL} alt="Profile" style={{ width: '30px', borderRadius: '50%', marginRight: '10px' }} />
            <span style={{ color: 'white', marginRight: '10px' }}>{user.displayName}</span>
            <span style={mobileLinkStyle} onClick={handleLogout}>Logout</span>
          </>
        ) : (
          <span style={mobileLinkStyle} onClick={handleLogin}>Login</span>
        )}
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div style={mobileMenuStyle}>
          <Link to="/" style={mobileLinkStyle} onClick={() => setIsMobileMenuOpen(false)}>Home</Link>
          <Link to="/faq" style={mobileLinkStyle} onClick={() => setIsMobileMenuOpen(false)}>Faq</Link>
          <Link to="/join" style={mobileLinkStyle} onClick={() => setIsMobileMenuOpen(false)}>Join</Link>
          <Link to="/discord" style={mobileLinkStyle} onClick={() => setIsMobileMenuOpen(false)}>Discord</Link>
          <Link to="/support" style={mobileLinkStyle} onClick={() => setIsMobileMenuOpen(false)}>Help & Support</Link>
          {user ? (
            <span style={mobileLinkStyle} onClick={handleLogout}>Logout</span>
          ) : (
            <span style={mobileLinkStyle} onClick={handleLogin}>Login</span>
          )}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
